<template>
  <div>
    <div class="jtitle">
      <h2 class="jtext">推荐信进度</h2>
    </div>
    <div class="table">
      <div class="search flex">
        <div class="seaicon">
          <img src="../../assets/icon/搜索@3x.png" height="20" width="20" />
        </div>
        <el-input v-model.trim="name" @input="search" class="seasubfix">
        </el-input>
      </div>
      <div :style="{ paddingRight: loading ? '5px' : 0, position: 'relative' }">
        <el-popover placement="bottom-end" trigger="click" width="280">
          <div>
            选择产出推荐信的月份
          </div>
          <el-date-picker
            v-model="exportMonth"
            type="month"
            placeholder="选择月份"
            class="date"
            value-format="yyyy-MM"
          >
          </el-date-picker>
          <el-radio-group v-model="exportType">
            <el-radio :label="1">按创建日期</el-radio>
            <el-radio :label="2">按推荐信日期</el-radio>
          </el-radio-group>
          <el-button
            class="exportConfirm"
            type="primary"
            @click="exportConfirm"
          >
            导表
          </el-button>
          <el-button slot="reference" class="export" type="primary">
            导表
          </el-button>
        </el-popover>
        <el-table
          :data="recommendations"
          ref="tableScroll"
          :height="tableHeight"
          :row-class-name="statusClass"
        >
          <el-table-column
            key="1"
            prop="status"
            label="推荐信状态"
            align="center"
            min-width="4%"
            :filters="filtersRule"
            :filter-method="filterHandler"
            column-key="status"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                :content="status[getStatus(scope.row)].label"
                effect="light"
                popper-class="atooltip"
              >
                <div
                  class="circle"
                  :style="{
                    'background-color': status[getStatus(scope.row)].color
                  }"
                ></div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            key="2"
            prop="created"
            label="创建日期"
            align="center"
            min-width="5%"
          />
          <el-table-column
            key="6"
            prop="teacher"
            label="导师"
            align="center"
            min-width="5%"
          />
          <el-table-column
            key="3"
            prop="student"
            label="学生"
            align="center"
            min-width="5%"
          >
          </el-table-column>
          <el-table-column
            key="4"
            prop="project_type"
            label="项目"
            align="center"
            min-width="5%"
          />
          <el-table-column
            key="5"
            prop="finish"
            label="辅导进度"
            align="center"
            min-width="5%"
          >
            <template slot-scope="scope">
              {{ scope.row.finish ? '完成辅导' : '未完成辅导' }}
            </template>
          </el-table-column>
          <el-table-column
            key="7"
            prop="identity"
            label="要求导师身份"
            align="center"
            min-width="10%"
          >
          </el-table-column>
          <el-table-column
            key="8"
            prop="deadline"
            label="deadline"
            align="center"
            min-width="5%"
          >
          </el-table-column>
          <el-table-column
            key="9"
            prop="misc"
            label="备注"
            align="center"
            min-width="5%"
          >
          </el-table-column>
          <el-table-column
            key="10"
            prop="assigner"
            label="翻译"
            align="center"
            min-width="5%"
          >
            <template slot-scope="scope">
              {{ scope.row.assigner }}
              <el-button class="listedit" @click="addassigner(scope.row)">
                <i class="el-icon-edit"></i>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column key="11" align="center" min-width="10%">
            <template slot-scope="scope">
              <div class="flex">
                <information-button :pid="scope.row.pid"></information-button>
                <final-button :pid="scope.row.pid"></final-button>
                <el-button type="primary" @click="uploadFile(scope.row)">
                  上传文件
                </el-button>
              </div>
            </template>
          </el-table-column>
          <div slot="append" style="text-align: center; font-size: 16px">
            <span v-if="loading && page === 1">
              <i class="eliwise-loading"></i>加载中请稍后...
            </span>
            <span v-else-if="has_next && recommendations.length > 0">
              下滑加载更多
            </span>
            <span v-else-if="recommendations.length === 0 && !loading">
              暂无数据
            </span>
            <i v-else>--没有更多数据了--</i>
          </div>
        </el-table>
      </div>
    </div>
    <el-dialog :visible="put" title="翻译" width="400px">
      <form name="recommendationForm" @submit.prevent="confirm">
        <el-input v-model="assigner" autocomplete="on" name="recommendations" />
        <div style="text-align: right;margin-top: 30px;margin-bottom: 10px;">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" native-type="submit">确定</el-button>
        </div>
      </form>
    </el-dialog>
    <el-dialog :visible="upload" title="上传推荐信" width="400px">
      <el-upload
        :action="uploadUrl"
        drag
        :limit="1"
        :on-success="success"
        ref="upload"
      >
        <div style="margin-top:75px">
          将文件拖到此处，或
          <em style="color: #8dc152; text-decoration: underline">
            点击上传
          </em>
        </div>
      </el-upload>
      <div slot="footer">
        <el-button @click="uploadcancel">取消</el-button>
        <el-button type="primary" :disabled="pending" @click="uploadconfirm">
          确定
        </el-button>
        <i
          class="el-icon-loading"
          style="position: absolute;margin-top: 5px;margin-left: 5px;"
          v-if="pending"
        ></i>
      </div>
    </el-dialog>
    <iframe name="targetIfr" style="display:none"></iframe>
  </div>
</template>

<script>
import axios from '../axios'
import { debounce } from 'lodash'
import informationButton from './buttons/informationButton'
import finalButton from './buttons/finalButton.vue'
import moment from 'moment'
export default {
  name: 'recommendations',
  components: {
    informationButton,
    finalButton
  },
  data () {
    return {
      uploadUrl: `${axios.defaults.baseURL}/upload/`,
      status: {
        0: {
          label: '待领取',
          color: '#c0c0c0'
        },
        1: {
          label: '翻译中',
          color: '#F7B500'
        },
        2: {
          label: '翻译完成',
          color: '#A1D46A'
        },
        3: {
          label: '逾期未完成',
          color: '#FA6400'
        }
      },
      recommendations: [],
      name: '',
      loading: false,
      tableHeight: window.innerHeight - 155,
      has_next: true,
      has_previous: false,
      page: 1,
      total_pages: 1,
      total_count: 0,
      page_size: 20,
      api: '',
      put: false,
      assigner: '',
      assignerid: 0,
      upload: false,
      key: '',
      pid: 0,
      filtersRule: [
        { text: '待领取', value: 0 },
        { text: '翻译中', value: 1 },
        { text: '翻译完成', value: 2 },
        { text: '逾期未完成', value: 3 }
      ],
      pending: false,
      exportMonth: moment(Date.now())
        .subtract(1, 'months')
        .format('YYYY-MM'),
      exportType: 1
    }
  },

  mounted () {
    this.loading = true
    this.api = this.$store.state.roleApi
    this.fetchRecommendations()
    this.$nextTick(() => {
      this.addScrollListener()
    })
  },
  methods: {
    fetchRecommendations (isLoadMore = false) {
      const params = {
        page: this.page,
        page_size: this.page_size
      }

      if (this.name) {
        params.name = this.name
      }

      this.loading = !isLoadMore

      return axios
        .get(`${this.api}/recommendations`, { params })
        .then(response => {
          if (response.data.has_previous) {
            this.recommendations = this.recommendations.concat(response.data.recommendations)
          } else {
            this.recommendations = response.data.recommendations
          }

          this.has_next = response.data.has_next
          this.has_previous = response.data.has_previous
          this.page = response.data.page
          this.total_pages = response.data.total_pages
          this.total_count = response.data.total_count
        })
        .finally(() => {
          this.loading = false
        })
    },

    addScrollListener () {
      this.scrollDom = this.$refs.tableScroll.bodyWrapper
      this.scrollDom.addEventListener('scroll', this.handleScroll)
    },

    handleScroll () {
      let scrollTop = this.scrollDom.scrollTop
      let windowHeight = this.scrollDom.clientHeight || this.scrollDom.clientHeight
      let scrollHeight = this.scrollDom.scrollHeight || this.scrollDom.scrollHeight
      if (scrollTop + windowHeight >= scrollHeight && this.has_next) {
        this.page = this.page + 1
        this.fetchRecommendations(true)
      }
    },

    filterHandler (value, row, column) {
      return this.getStatus(row) === value
    },
    uploadFile (row) {
      this.upload = true
      this.pid = row.pid
    },
    success (res) {
      this.key = res.key
    },
    uploadcancel () {
      this.$refs.upload.clearFiles()
      this.key = ''
      this.upload = false
      this.pending = false
      this.pid = 0
    },
    exportConfirm () {
      window.open(
        `${axios.defaults.baseURL}/${this.api}/recommendation/exportConfirm?month=${this.exportMonth}&type=${this.exportType}`,
        '_blank'
      )
    },
    uploadconfirm () {
      if (this.key === '') {
        this.$message({
          showClose: true,
          message: '文件不能为空',
          type: 'error'
        })
        return
      }
      this.pending = true
      axios
        .post(`${this.api}/project/${this.pid}/recommendation`, {
          key: this.key
        })
        .then(res => {
          if (res.status === 200) {
            this.page = 1
            this.fetchRecommendations()
            this.$message({
              showClose: true,
              message: '上传成功',
              type: 'success'
            })
            this.uploadcancel()
          }
        })
        .catch(res => {
          this.pending = false
        })
    },
    addassigner (row) {
      this.put = true
      this.assigner = row.assigner
      this.assignerid = row.id
    },
    cancel () {
      this.put = false
      this.assigner = ''
    },
    confirm () {
      axios
        .post(`${this.api}/recommendation/${this.assignerid}/assigner`, {
          assigner: this.assigner
        })
        .then(res => {
          if (res.status === 200) {
            this.page = 1
            this.fetchRecommendations()
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success'
            })
            this.cancel()
          }
        })
    },
    getStatus (row) {
      if (row.status === 2) {
        return 2
      }
      let now = new Date()
      let deadline = new Date(Date.parse(row.deadline.replace('-', '/')))
      if (now > deadline) {
        return 3
      } else {
        return row.status
      }
    },
    statusClass ({ row }) {
      if (row.pro_status === 2) {
        return 'finished'
      }
    },
    search: debounce(function () {
      this.loading = true
      this.page = 1
      this.scrollDom.scrollTop = 0
      this.fetchRecommendations()
    }, 1000)
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-table .cell {
  text-overflow: clip;
}
/deep/.finished .cell {
  color: #c0c0c0;
}
/deep/.flex {
  .el-button {
    margin-left: 10px;
  }
}
.circle {
  width: 12px;
  height: 12px;
  margin: 2px auto;
  border-radius: 50%;
  cursor: pointer;
}
.export {
  position: absolute;
  right: 0;
  top: 8px;
  z-index: 100;
}
/deep/.el-input__icon {
  line-height: 30px;
}
.date {
  width: 100%;
}
.exportConfirm {
  width: 100%;
  margin-top: 20px;
}
</style>
